import { isNullOrUndefined } from 'util';

import { IAddress } from '@app/model/interfaces/IAddress';
import { IServicePersonalInformation } from '@app/model/interfaces/IServicePersonalInformation';

export class Address implements IAddress {
  city: string;
  line1: string;
  line2: string;
  state: string;
  zip: string;

  constructor(address: IServicePersonalInformation) {
    this.line1 = address.address;
    this.line2 = address.address2;
    this.state = address.state;
    this.city = address.city;
    this.zip = address.zip;
  }

  public isValid(): boolean {
    return (
      !isNullOrUndefined(this.city) &&
      this.city !== '' &&
      !isNullOrUndefined(this.state) &&
      this.state !== '' &&
      !isNullOrUndefined(this.line1) &&
      this.line1 !== '' &&
      !isNullOrUndefined(this.zip) &&
      this.zip !== '' &&
      this.zip.toString().length === 5
    );
  }
}
